import React from "react";
import styled from "styled-components";
import PageHeader from "../../components/PageHeader.tsx";
import Scrollbars from "react-custom-scrollbars-2";
import PaginatedItems from "../../components/PaginatedItems.tsx";
import ProductTile from "../../components/core-components/ProductTile.tsx";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getProductByCategoryId } from "../../../services/productsService.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  box-sizing: border-box;
  background-color: white;
  width: calc(100% - 2rem);
  height: 100vh;
  border-radius: 8px;
  padding: 20px;
  overflow-x: auto; /* Enable horizontal scroll */
  overflow-y: auto; /* Optional: keep vertical scroll */

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

interface Props {}

const DashboardProductsPage: React.FC<Props> = ({}) => {
  const { categoryId } = useParams();
  const navigate = useNavigate();

  interface Product {
    productID: number;
    productName: string;
    price: number;
    imageUrls: string[] | null;
    discount: number;
  }

  const { data: products, isLoading } = useQuery<Product[]>({
    queryKey: ["products", categoryId],
    queryFn: () => getProductByCategoryId(categoryId),
  });

  // const products = [
  //   {
  //     productID: 1,
  //     productName: "Product 1",
  //     price: 100,
  //     images: null,
  //     discount: 10,
  //   },
  //   {
  //     productID: 2,
  //     productName: "Product 2",
  //     price: 200,
  //     images: null,
  //     discount: 20,
  //   },
  //   {
  //     productID: 3,
  //     productName: "Product 3",
  //     price: 300,
  //     images: null,
  //     discount: 30,
  //   },
  //   {
  //     productID: 4,
  //     productName: "Product 4",
  //     price: 400,
  //     images: null,
  //     discount: 40,
  //   },
  //   {
  //     productID: 5,
  //     productName: "Product 5",
  //     price: 500,
  //     images: null,
  //     discount: 50,
  //   },
  //   {
  //     productID: 6,
  //     productName: "Product 6",
  //     price: 600,
  //     images: null,
  //     discount: 60,
  //   },
  //   {
  //     productID: 7,
  //     productName: "Product 7",
  //     price: 700,
  //     images: null,
  //     discount: 70,
  //   },
  //   {
  //     productID: 8,
  //     productName: "Product 8",
  //     price: 800,
  //     images: null,
  //     discount: 80,
  //   },
  //   {
  //     productID: 9,
  //     productName: "Product 9",
  //     price: 900,
  //     images: null,
  //     discount: 90,
  //   },
  // ];

  return (
    <Wrapper>
      <PageHeader
        pageTitle="Produse"
        actionButtons={[
          {
            label: "Adaugă produs",
            onClick: () => {
              navigate("product/new");
            },
            isEmpty: true,
          },
        ]}
      />

      {!products || products.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <h4>Nu există produse în această categorie</h4>
        </div>
      ) : (
        <Content>
          <Scrollbars style={{ width: "100%" }}>
            <PaginatedItems
              items={products}
              isLoading={isLoading}
              renderItem={(product) => (
                <ProductTile
                  key={product.productID}
                  id={product.productID.toString()}
                  name={product.productName}
                  price={product.price.toString()}
                  image={product.imageUrls ? product.imageUrls[0] : ""}
                  discount={product.discount.toString()}
                  onClick={() => navigate(`product/${product.productID}`)}
                />
              )}
              maxItemsPerPage={15}
            />
          </Scrollbars>
        </Content>
      )}
    </Wrapper>
  );
};

export default DashboardProductsPage;
